var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6094 0 24 5.39062 24 12C24 18.6562 18.6094 24 12 24C5.34375 24 0 18.6562 0 12C0 5.39062 5.34375 0 12 0ZM16.7812 13.0781C17.0625 12.7969 17.25 12.4219 17.25 12C17.25 11.625 17.0625 11.25 16.7812 10.9688L11.5312 5.71875C10.9688 5.10938 9.98438 5.10938 9.42188 5.71875C8.8125 6.28125 8.8125 7.26562 9.42188 7.82812L13.5938 12L9.42188 16.2188C8.8125 16.7812 8.8125 17.7656 9.42188 18.3281C9.98438 18.9375 10.9688 18.9375 11.5312 18.3281L16.7812 13.0781Z",
    fill: "#F67924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMore);
export default __webpack_public_path__ + "static/media/showMore.e6ff52129ee0616e8ef7f2a24434a2f1.svg";
export { ForwardRef as ReactComponent };